import React, { Component } from "react";
import "./Appointment.scss";
import Lopd from "./Lopd/Lopd";
import WearPiecesJSON from "../../../data/WearPieces.json";
import arrayStar from "../../../data/arrayStar";
import sendEventoGTM from "../../../utils/tags";
import adesisServices from "../../../services/adesisServices.js";

export default class Appointment extends Component {
  constructor() {
    super();
    this.state = {
      showMailModal: false,
      isAccepted: false,
      isEmailOk: false,
      isEmailSent: { isSent: false, error: false },
      isRedirect: false,
      email: "",
      date: `${new Date().getDate()}/${new Date().getMonth() +
        1}/${new Date().getFullYear()}`
    };
    this.adesisServices = new adesisServices();
  }

  toggleMailModal = () => {
    this.setParentPosition();
    this.setState({ ...this.state, showMailModal: !this.state.showMailModal });
  };

  closeMailSent = () => {
    this.setState({ ...this.state, isEmailSent: false });
  };

  emailHandle = e => {
    const { value } = e.target;
    if (
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        String(value).toLowerCase()
      )
    ) {
      this.setState({
        ...this.state,
        isEmailOk: true,
        email: value
      });
    } else {
      this.setState({
        ...this.state,
        isEmailOk: false,
        email: value
      });
    }
  };

  accepted = () => {
    this.setState({ ...this.state, isAccepted: !this.state.isAccepted });
  };

  citaPreviaRedirect = () => {
    window.open(
      "https://citaprevia.lexusauto.es/",
      "_blank"
    );
  };

  sendEmail = () => {
    if (this.state.isAccepted && this.state.isEmailOk) {
      let pieces = [];
      let mantenimientoV = [];
      let mantenimientoR = [];

      this.props.thingsToDo.map(piece => {
        if (piece.cTipo.includes("V")) {
          if (arrayStar.includes(piece.cDescripcion)) {
            mantenimientoV.push({
              img:
                "https://testmadrid2.adesis.com/testdrive-services/images/toyota/CalculadoraMantenimiento/star.png",
              descripcion: piece.cDescripcion,
              show: "true",
              tipo: "V"
            });
          } else {
            mantenimientoV.push({
              img:
                "https://testmadrid2.adesis.com/testdrive-services/images/toyota/CalculadoraMantenimiento/check.png",
              descripcion: piece.cDescripcion,
              show: "true",
              tipo: "V"
            });
          }
        } else {
          if (arrayStar.includes(piece.cDescripcion)) {
            mantenimientoR.push({
              img:
                "https://testmadrid2.adesis.com/testdrive-services/images/toyota/CalculadoraMantenimiento/star.png",
              descripcion: piece.cDescripcion,
              show: "true",
              tipo: "R"
            });
          } else {
            mantenimientoR.push({
              img:
                "https://testmadrid2.adesis.com/testdrive-services/images/toyota/CalculadoraMantenimiento/check.png",
              descripcion: piece.cDescripcion,
              show: "true",
              tipo: "R"
            });
          }
        }
      });

      const hybridVerification = {
        img:
          "https://testmadrid2.adesis.com/testdrive-services/images/toyota/CalculadoraMantenimiento/star.png",
        descripcion: "<b>Chequeo Integral del Sistema Híbrido.</b>",
        show: "true",
        tipo: "V"
      };

      mantenimientoV.push({
        img:
          "https://testmadrid2.adesis.com/testdrive-services/images/toyota/CalculadoraMantenimiento/star.png",
        descripcion:
          "<b>Inspección del estado de salud del vehículo (componentes mecánicos y electrónicos).</b>",
        show: "true",
        tipo: "V"
      });

      this.props.fuelSelected === "Híbrido" &&
        mantenimientoV.push(hybridVerification);

      this.props.carInfo &&
        this.props.carInfo.fuel === "Híbrido" &&
        mantenimientoV.push(hybridVerification);

      WearPiecesJSON.map((piece, i) => {
        pieces.push({
          show: `${
            this.props.wearPiecesInfo
              ? this.props.wearPiecesInfo[i].pieceNotAvailable
                ? "false"
                : this.props.pieces[i]
              : null
          }`,
          name: piece.name,
          img: piece.img.substring(1),
          prize: `${
            this.props.wearPiecesInfo && this.props.wearPiecesInfo[i].totalField
              ? this.props.wearPiecesInfo[i].totalField.toFixed(2).toString()
              : null
          }€`
        });
      });

      let showWearPartsContainer;
      if (
        this.props.pieces[0] === false &&
        this.props.pieces[1] === false &&
        this.props.pieces[2] === false &&
        this.props.pieces[3] === false &&
        this.props.pieces[4] === false &&
        this.props.pieces[5] === false &&
        this.props.pieces[6] === false &&
        this.props.pieces[7] === false
      ) {
        showWearPartsContainer = "false";
      } else {
        showWearPartsContainer = "";
      }

      let sendEmaildata = {
        emailConfigureDTO: {
          to: this.state.email,
          Subject: 'Tu presupuesto de mantenimiento'
        },
        calculadoraMantenimientoDTO: {
          model: this.props.selectedModel.nameCase,
          date: this.state.date,
          workshop: `${this.props.selectedWorkshops.DealershipName} ${
            this.props.selectedWorkshops.DealershipAddress
          } ${this.props.selectedWorkshops.DealershipZipCode}`,
          precioNoIncluyeAdblue: this.props.precioNoIncluyeAdblue,
          maintenanceCost:
            this.props.maintenanceCost.toFixed(2).replace(".", ",") + "€",
          wearPartsCost:
            this.props.wearPartsCost.toFixed(2).replace(".", ",") + "€",
          totalPrize:
            (this.props.maintenanceCost + this.props.wearPartsCost)
              .toFixed(2)
              .toString()
              .replace(".", ",") + "€",
          engineName:
            this.props.carInfo !== undefined
              ? this.props.carInfo.engineName
              : this.props.engineNameSelected,
          fuel: this.props.carInfo
            ? this.props.carInfo.fuel
            : this.props.fuelSelected,
          gearBoxName:
            this.props.carInfo !== undefined
              ? this.props.carInfo.gearBoxName
              : this.props.gearBoxNameSelected,
          year:
            this.props.carInfo !== undefined
              ? this.props.carInfo.year
              : this.props.yearSelected,
          distanceSelected: this.props.distanceSelected,
          pieces: pieces,
          mantenimientoV: mantenimientoV,
          mantenimientoR: mantenimientoR,
          showWearPartsContainer
        }
      };

      this.adesisServices
        .sendMail(sendEmaildata)
        .then(response => {
          if (response.data.ResponseStatus === 0) {
            this.setState({
              ...this.state,
              isEmailSent: { isSent: true, error: false },
              loading: false
            });
          } else {
            this.setState({
              ...this.state,
              isEmailSent: { isSent: true, error: true },
              loading: false
            });
          }
        })
        .catch(error => {
          console.log(error);
          this.setState({ ...this.state, loading: false });
        });
    }
  };

  loadingActivator = () => {
    this.setState({ ...this.state, loading: true });
  };

  setParentPosition = () => {
    let sData;
    let auxArr;
    let parentPosition = 2077;
    let windowHeigh = 850;
    window.parent.postMessage("Modal", process.env.REACT_APP_POSTMSG);
    this.receiveMessage = event => {
      sData = event.data.toString();
      if(sData.indexOf("-")){
        auxArr = sData.split("-");
        parentPosition = Number(auxArr[1]);
        windowHeigh = Number(auxArr[0]);
      }
      this.setState({ ...this.state, parentPosition, windowHeigh }, () => {});
     
    };
    window.addEventListener("message", this.receiveMessage, false);
  };

  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="title appointment-title">
              <h3 className="small-title text-center">
                Ahora que ya sabes lo que costará tu mantenimiento, ¡pide cita
                con tu taller!
              </h3>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="buttons-container">
              {/* <button
                onClick={() => {
                  this.citaPreviaRedirect();
                  // CTA / Book Service
                  sendEventoGTM(
                    "1-book-service",
                    "0"
                  );
                }}
                className="mm-button mm-rounded mm-red"
              >
                Pedir cita
              </button> */}
              <button class="button_mostrar_mas btn-descubrir" type="button" onClick={ () => { this.citaPreviaRedirect(); sendEventoGTM(
                    "1-book-service",
                    "0"
                  )}}>
                <span class="btn-vehiculos">
                  PEDIR CITA
                </span>
                <span class="linea-boton"></span>
              </button>
              {/* <button
                className="mm-button mm-rounded mm-gray"
                onClick={() => {
                  // CTA / Print
                  sendEventoGTM(
                    "print-maintenance",
                    "1",
                    
                  );
                  window.print();
                }}
              >
                Imprimir
              </button> */}
              <button class="button_mostrar_mas btn-descubrir" type="button" onClick={ () => { sendEventoGTM(
                    "print-maintenance",
                    "1",
                  );
                  window.print();}}>
                <span class="btn-vehiculos">
                  IMPRIMIR
                </span>
                <span class="linea-boton"></span>
              </button>
              {/* <button
                className="mm-button mm-rounded mm-outline"
                onClick={() => {
                  this.toggleMailModal();
                  // CTA / Email
                  sendEventoGTM(
                    "1-email-maintenance",
                    "0"
                  );
                }}
              >
                Enviar por email
              </button> */}
            </div>
          </div>
        </div>

        {this.state.showMailModal ? (
          <div className="row">
            <div className="col-12">
              <div className="email-box__container">
                <div className="email-box__input-title">E-mail</div>
                <div className="email-box__input">
                  <input
                    type="email"
                    placeholder="Introduce una dirección de email"
                    onChange={e => {
                      this.emailHandle(e);
                    }}
                  />
                </div>
                <div className="row">
                  <p class="text_politica">
                    Los datos de contacto facilitados por usted, se incorporan a la Base de Datos de Clientes TOYOTA (del que son responsables su Concesionario habitual, Toyota España, S.L.U., Toyota Motor Europe, S.L.U., y,
                    en caso de que tenga interés por sus servicios, Toyota Kreditbank, GMBH, Sucursal en España, Aioi Nissai Dowa Insurance Company of Europe Limited, Sucursal en España y Toyota Insurance Management, Ltd, Sucursal en España,
                    todas ellas domiciliadas a estos efectos en Avda. de Bruselas, 22, 28109 Alcobendas Madrid) con la finalidad de gestionar su petición, encuesta de satisfacción con el servicio prestado y realizar las estadísticas y estudios necesarios para la mejora de sus productos y servicios. 
                    El tratamiento de sus datos es necesario para la ejecución de su petición (legitimación: contractual).
                    Para enviar comunicaciones comerciales relacionadas con TOYOTA le solicitaremos su consentimiento, a estos efectos, recibirá un email para que confirme su voluntad de recibir comunicaciones de la Marca. El plazo de conservación de los datos será de un año, mientras no se solicite su supresión por el interesado.
                    No se cederán datos a terceros salvo obligación legal o que sea necesario para prestar un servicio solicitado por el Cliente.
                    Podrá ejercer los derechos de acceso, rectificación, supresión y portabilidad de sus datos y limitación u oposición a su tratamiento o retirar el consentimiento prestado, dirigiendo comunicación
                    escrita o email a Avda. de Bruselas, 22, 28109 Alcobendas Madrid, Ref. “Protección de Datos Clientes TOYOTA” o a
                    <a class="link-text" href="mailto:clientes@toyota.es"> clientes@toyota.es</a>. Asimismo, tiene derecho de presentar
                    reclamación ante <a class="link-text" href="mailto:dpo@toyota.es"> dpo@toyota.es</a> y/o la Agencia Española de
                    Protección de Datos. Consulte más información en 
                    <a class="link-text" href="https://www.toyota.es/informacion-adicional-proteccion-de-datos" target="_blank" rel="noreferrer noopener"> https://www.toyota.es/informacion-adicional-proteccion-de-datos</a>
                  </p>
                </div>
                <div className="email-box__checkbox">
                  <label className="checkbox-inline">
                    <input
                      className="marginR"
                      type="checkbox"
                      onClick={() => this.accepted()}
                      value=""
                    />
                    <p>
                      Confirmo haber leído y aceptado la 
                      <a class="link-text" href="https://www.toyota.es/informacion-adicional-proteccion-de-datos" target="_blank" rel="noreferrer noopener"> política de protección de datos</a>
                    </p>
                  </label>
                  <Lopd parentPosition={this.state.parentPosition} />
                </div>
                <div>
                  <div
                    className={`modal-header ${
                      this.state.isEmailSent.error ? "red-modal" : "green"
                    } ${
                      this.state.isEmailSent.isSent
                        ? "emailSent"
                        : "emailNotSent"
                    }`}
                  >
                    {this.state.isEmailSent.error ? (
                      <p className="align-text-close">
                        No hemos podidio enviar tu solicitud. Prueba en otro
                        momento{" "}
                      </p>
                    ) : (
                      <p className="align-text-close">
                        En breve recibirás tu presupuesto. Muchas gracias.{" "}
                      </p>
                    )}
                    <button
                      type="button"
                      className="padding close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={this.closeMailSent}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>

                <div
                  data-toggle="modal"
                  data-target="#emailSend"
                  className="email-box__button-container"
                >
                  <button
                    data-toggle="modal"
                    data-target="#emailSent"
                    onClick={() => {
                      this.state.isAccepted &&
                        this.state.isEmailOk &&
                        this.sendEmail();
                      this.state.isAccepted &&
                        this.state.isEmailOk &&
                        this.loadingActivator();
                      // Email form submission
                      sendEventoGTM(
                        "2-email-maintenance-submit",
                        "1"
                      );
                    }}
                    className={`mm-button mm-rounded mm-black ${
                      this.state.isAccepted && this.state.isEmailOk
                        ? ""
                        : "disabled"
                    }`}
                  >
                    Enviar
                  </button>
                  {this.state.loading && (
                    <div className="loader-plate-container">
                      <img
                        className="loader-plate"
                        src="./images/spinner.gif"
                        alt="loader"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
